/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop, getAssetPath } from '@stencil/core';
import { Memoize, parseIfString } from '@springbokagency/stencil-base';
import type { EfbButton } from '../../atoms/button/button';

/**
 * Failsurance card component.
 */
@Component({
  tag: 'efb-failsurance-card',
  styleUrl: 'failsurance-card.scss',
  shadow: true,
})
export class EfbFailsuranceCard {
  @Prop() titleText: string;

  @Prop() text: string;

  @Prop() subtitle?: string;

  @Prop() button: EfbButton | string;

  @Memoize('button')
  get parsedButton(): EfbButton {
    return parseIfString(this.button);
  }

  @Prop() legalMention?: string;

  render() {
    return (
      <Host>
        <div class="failsurance-card">
          {/* Decoration icon */}
          <div class="decoration-icon">
            <img
              src={getAssetPath('/dist/assets/images/icons/L-icon.svg')}
              alt=""
              role="presentation"
            />
          </div>

          <div class="text-wrapper">
            {/* Title */}
            {this.titleText && (
              <efb-title text={this.titleText} tag="h2" size="sm" bottomMargin="sm">
                <em class="title-accent" aria-label="Failsurance">
                  Fai
                  <img
                    class="learner-sign"
                    src={getAssetPath('/dist/assets/images/icons/learner-sign.svg')}
                    alt="L"
                    loading="lazy"
                  />
                  surance
                </em>
              </efb-title>
            )}

            {/* Subtitle */}
            {this.subtitle && (
              <efb-title text={this.subtitle} tag="span" size="xs" bottomMargin="sm" bold />
            )}

            {/* Text */}
            {this.text && <efb-paragraph text={this.text} size="base" bottomMargin="lg" />}

            {/* Button */}
            {this.parsedButton && (
              <efb-button class="button" {...this.parsedButton} variant="teal" />
            )}

            {/* Legal mention */}
            {this.legalMention && (
              <efb-paragraph class="legal-mention" text={this.legalMention} size="base" />
            )}
          </div>

          <div class="image-wrapper">
            <picture>
              <source
                media="(max-width: 768px)"
                srcSet={`${getAssetPath(
                  '/dist/assets/images/ethis/ethis-robbie-card-mobile.webp'
                )}, ${`${getAssetPath(
                  '/dist/assets/images/ethis/ethis-robbie-card-mobile@2x.webp'
                )} 2x`}`}
                type="image/webp"
              />
              <source
                media="(min-width: 769px)"
                srcSet={`${getAssetPath(
                  '/dist/assets/images/ethis/ethis-robbie-card-desktop.webp'
                )}, ${`${getAssetPath(
                  '/dist/assets/images/ethis/ethis-robbie-card-desktop@2x.webp'
                )} 2x`}`}
                type="image/webp"
              />
              <img
                class="img"
                src={getAssetPath('/dist/assets/images/ethis/ethis-robbie-card-desktop.png')}
                srcset={`${getAssetPath(
                  '/dist/assets/images/ethis/ethis-robbie-card-desktop@2x.png'
                )} 2x`}
                role="presentation"
                loading="lazy"
              />
            </picture>
          </div>
        </div>
      </Host>
    );
  }
}
